import React from "react";
import { Lock, Shield } from "lucide-react";

const AccessDenied = () => {
  return (
    <div>
      <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 flex items-center justify-center p-4">
        <div className="max-w-md w-full">
          <div className="bg-white rounded-2xl shadow-xl border border-gray-200 overflow-hidden">
            <div className="bg-gradient-to-r from-red-500 to-red-600 px-6 py-8 text-center">
              <div className="w-16 h-16 bg-white bg-opacity-20 rounded-full flex items-center justify-center mx-auto mb-4">
                <Shield className="w-8 h-8 text-white" />
              </div>
              <h1 className="text-2xl font-bold text-white mb-2">
                Access Restricted
              </h1>
            </div>

            {/* Content */}
            <div className="px-6 py-8">
              <div className="text-center mb-6">
                <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Lock className="w-6 h-6 text-red-600" />
                </div>
                <h2 className="text-xl font-semibold text-gray-900 mb-3">
                  Create Rules Permission Required
                </h2>
                <p className="text-gray-600 leading-relaxed">
                  You currently don't have permission to create mapping rules.
                  Contact your system administrator to request access to this
                  feature.
                </p>
              </div>
            </div>

            {/* Footer */}
            <div className="bg-gray-50 px-6 py-4 border-t border-gray-200">
              <p className="text-xs text-gray-500 text-center">
                Access permissions are managed by Onboarding Manager.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccessDenied;
